import { createSelector } from 'reselect';
import { lastRoundHighsSelector } from './simple-selectors';

export const lastRoundHighsRoundDataSelector = createSelector(
    lastRoundHighsSelector,
    // @ts-ignore
    lastRoundHighs => lastRoundHighs.roundData
);